export const cleanUndefinedDeep = <T>(obj: T, seen = new WeakSet(), depth = 0): T => {
  // Handle primitives, null, and undefined
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }

  // Prevent excessive recursion depth
  if (depth > 50) {
    const error = new Error(`[cleanUndefinedDeep] Maximum depth (${depth}) exceeded. This indicates a data structure issue.`);
    if (__DEV__) {
      console.warn(error);
    }
    throw error;
  }

  // Check for circular references
  if (seen.has(obj as any)) {
    const error = new Error(`[cleanUndefinedDeep] Circular reference detected at depth ${depth}. This is a bug in data construction.`);
    if (__DEV__) {
      console.warn(error);
    }
    throw error;
  }

  // Add current object to seen set
  seen.add(obj as any);

  // Handle arrays
  if (Array.isArray(obj)) {
    return obj.map((item) => cleanUndefinedDeep(item, seen, depth + 1)) as unknown as T;
  }

  // Handle objects
  const newObj: any = {};
  Object.entries(obj as any).forEach(([key, value]) => {
    if (value !== undefined) {
      newObj[key] = cleanUndefinedDeep(value, seen, depth + 1);
    }
  });
  return newObj;
}; 